import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import { Button, Flex, Skeleton, Space, Typography } from 'antd';
import { Input } from 'antd';
import { Card } from 'antd';
import React from 'react';

const OrganizationPage = () => {
  const { getAccessTokenSilently } = useAuth0();

  const data = useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const res = await axios.get('https://uvn7lxruic.execute-api.eu-west-1.amazonaws.com/prod/consumers/me', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return res.data;
    },
  });

  const handleCopyToken = async () => {
    const token = data?.data?.consumer?.api_tokens[0]?.exportedToken;
    if (token) {
      await navigator.clipboard.writeText(token);
    }
  };
  const [passwordVisible, setPasswordVisible] = React.useState(false);

  if (data.isLoading || data.isFetching) {
    return <Skeleton active />;
  }

  if (data?.data?.consumer) {
    return (
      <Flex vertical={true} gap={'middle'}>
        <Typography.Title level={3}>
          {data?.data?.consumer.legal_name}, {data?.data?.consumer.email}
        </Typography.Title>

        <Card>
          <Flex vertical={true} gap={'middle'}>
            <Typography.Text strong>Production API endpoint:</Typography.Text>

            <Typography.Text code>https://api.alignlabs.dev</Typography.Text>

            <Typography.Text strong>Production API Key:</Typography.Text>

            <Space direction="horizontal">
              <Input.Password
                value={data?.data?.consumer.api_tokens[0].exportedToken}
                visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }}
              />
              <Button icon={<ClipboardDocumentIcon width={15} />} onClick={handleCopyToken} style={{ width: 80 }}>
                Copy
              </Button>
            </Space>
          </Flex>
        </Card>
      </Flex>
    );
  }

  return (
    <div>
      <Typography.Text>To get started with our API and manage your keys, please contact us at:</Typography.Text>
      <br />
      <Typography.Text style={{ textDecoration: 'underline' }}>pavel@alignlabs.dev</Typography.Text>
    </div>
  );
};

export default OrganizationPage;
